import { collect } from "utils/classes/collection";

const colors = collect([
  {bgc:'rgba(255, 99, 132, 0.2)',bc:'rgba(255, 99, 132, 1)'},
  {bgc:'rgba(54, 162, 235, 0.2)',bc:'rgba(54, 162, 235, 1)'},
  {bgc:'rgba(255, 206, 86, 0.2)',bc:'rgba(255, 206, 86, 1)'},
  {bgc:'rgba(75, 192, 192, 0.2)',bc:'rgba(75, 192, 192, 1)'},
  {bgc:'rgba(153, 102, 255, 0.2)',bc:'rgba(153, 102, 255, 1)'},
  {bgc:'rgba(255, 159, 64, 0.2)',bc:'rgba(255, 159, 64, 1)'},
]);

export function getBackgroundColor(){
  return colors.pluck("bgc").toArray();
}

export function getBorderColor(){
  return colors.pluck("bc").toArray();
}

export function getColors(){
  let color = colors.shuffle()
  return {
    backgroundColor: color.pluck("bgc").toArray(),
    borderColor: color.pluck("bc").toArray(),
  }
}

